import { OnboardingStepType, OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { HealthcheckStatusResult, HealthcheckType } from '../types'
import { getOnboardingStepAssignee } from '../utils/onboardingWorkflowUtils'
import { mayManageAliceCardProgram } from './aliceCardProgramUtils'
import { isOrgFundingConnected } from './funding/fundingUtils'

export const useAliceCardProgramStatus = (
  org: OrganizationDetailFragment | null | undefined,
  onboardingWorkflow?: OrganizationDetailFragment['onboardingWorkflow']
): HealthcheckStatusResult | null => {
  const mayManage = mayManageAliceCardProgram(org)

  if (!org || !mayManage) {
    return null // Component doesn't render if user can't manage Alice Card Program
  }

  const fundingConnected = isOrgFundingConnected(org)
  const assignee = getOnboardingStepAssignee(onboardingWorkflow, OnboardingStepType.ConnectBanking)

  const healthcheckTitle = 'Contributions Account'
  const baseProperties = {
    assignee,
    healthcheckTitle,
    primary: healthcheckTitle,
    healthcheckType: HealthcheckType.ConnectBanking,
  } as const

  if (fundingConnected) {
    return {
      status: 'complete',
      secondary: 'Employee spend on Alice Card is funded',
      ...baseProperties,
    }
  }

  return {
    status: 'incomplete',
    secondary: 'Account must be connected to fund pretax benefits',
    ...baseProperties,
  }
}
